import i18n from "@/i18n";

// 所有状态
export const statusOptions = () => [
    {
        label: i18n.t("zhiji.common.allStatus"),
        value: "all"
    },
    {
        label: i18n.t("zhiji.knowlege.alreadyOn"),
        value: "online"
    },
    {
        label: i18n.t("zhiji.knowlege.alreadyOff"),
        value: "offline"
    },
    {
        label: i18n.t("zhiji.knowlege.draft"),
        value: "draft"
    }
];

